// extracted by mini-css-extract-plugin
export var button = "PayPalButton-module__button___C9psu";
export var logo = "PayPalButton-module__logo___AP0f_";
export var text = "PayPalButton-module__text___Ted0f";